// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";


export interface IDoubleValue {
    value?: number;

}
export class DoubleValue implements IDoubleValue {

    value?: number;

    constructor(data?: Partial<IDoubleValue>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MDoubleValue extends Message implements DoubleValue {

    constructor(data?: Partial<IDoubleValue>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new DoubleValue() : {} as DoubleValue;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeDouble(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IDoubleValue): Uint8Array {
        return (data instanceof Message ? (data as MDoubleValue) : new MDoubleValue(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MDoubleValue {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MDoubleValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readDouble();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MDoubleValue {
        return MDoubleValue.deserializeBinaryFromReader(new MDoubleValue(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MDoubleValue, reader: BinaryReader) {
        return Object.assign(msg, MDoubleValue.deserialize(reader))
    };

}
export interface IFloatValue {
    value?: number;

}
export class FloatValue implements IFloatValue {

    value?: number;

    constructor(data?: Partial<IFloatValue>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MFloatValue extends Message implements FloatValue {

    constructor(data?: Partial<IFloatValue>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new FloatValue() : {} as FloatValue;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeFloat(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IFloatValue): Uint8Array {
        return (data instanceof Message ? (data as MFloatValue) : new MFloatValue(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MFloatValue {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MFloatValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readFloat();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MFloatValue {
        return MFloatValue.deserializeBinaryFromReader(new MFloatValue(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MFloatValue, reader: BinaryReader) {
        return Object.assign(msg, MFloatValue.deserialize(reader))
    };

}
export interface IInt64Value {
    value?: number;

}
export class Int64Value implements IInt64Value {

    value?: number;

    constructor(data?: Partial<IInt64Value>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MInt64Value extends Message implements Int64Value {

    constructor(data?: Partial<IInt64Value>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Int64Value() : {} as Int64Value;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeInt64(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IInt64Value): Uint8Array {
        return (data instanceof Message ? (data as MInt64Value) : new MInt64Value(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MInt64Value {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MInt64Value();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readInt64();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MInt64Value {
        return MInt64Value.deserializeBinaryFromReader(new MInt64Value(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MInt64Value, reader: BinaryReader) {
        return Object.assign(msg, MInt64Value.deserialize(reader))
    };

}
export interface IUInt64Value {
    value?: number;

}
export class UInt64Value implements IUInt64Value {

    value?: number;

    constructor(data?: Partial<IUInt64Value>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MUInt64Value extends Message implements UInt64Value {

    constructor(data?: Partial<IUInt64Value>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new UInt64Value() : {} as UInt64Value;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeUint64(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IUInt64Value): Uint8Array {
        return (data instanceof Message ? (data as MUInt64Value) : new MUInt64Value(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MUInt64Value {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MUInt64Value();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readUint64();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MUInt64Value {
        return MUInt64Value.deserializeBinaryFromReader(new MUInt64Value(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MUInt64Value, reader: BinaryReader) {
        return Object.assign(msg, MUInt64Value.deserialize(reader))
    };

}
export interface IInt32Value {
    value?: number;

}
export class Int32Value implements IInt32Value {

    value?: number;

    constructor(data?: Partial<IInt32Value>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MInt32Value extends Message implements Int32Value {

    constructor(data?: Partial<IInt32Value>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Int32Value() : {} as Int32Value;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeInt32(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IInt32Value): Uint8Array {
        return (data instanceof Message ? (data as MInt32Value) : new MInt32Value(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MInt32Value {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MInt32Value();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MInt32Value {
        return MInt32Value.deserializeBinaryFromReader(new MInt32Value(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MInt32Value, reader: BinaryReader) {
        return Object.assign(msg, MInt32Value.deserialize(reader))
    };

}
export interface IUInt32Value {
    value?: number;

}
export class UInt32Value implements IUInt32Value {

    value?: number;

    constructor(data?: Partial<IUInt32Value>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MUInt32Value extends Message implements UInt32Value {

    constructor(data?: Partial<IUInt32Value>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): number {
        return Message.getField(this, 1) as number;
    }
    set value(value: number) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new UInt32Value() : {} as UInt32Value;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeUint32(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IUInt32Value): Uint8Array {
        return (data instanceof Message ? (data as MUInt32Value) : new MUInt32Value(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MUInt32Value {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MUInt32Value();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readUint32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MUInt32Value {
        return MUInt32Value.deserializeBinaryFromReader(new MUInt32Value(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MUInt32Value, reader: BinaryReader) {
        return Object.assign(msg, MUInt32Value.deserialize(reader))
    };

}
export interface IBoolValue {
    value?: boolean;

}
export class BoolValue implements IBoolValue {

    value?: boolean;

    constructor(data?: Partial<IBoolValue>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MBoolValue extends Message implements BoolValue {

    constructor(data?: Partial<IBoolValue>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): boolean {
        return Message.getField(this, 1) as boolean;
    }
    set value(value: boolean) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new BoolValue() : {} as BoolValue;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeBool(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IBoolValue): Uint8Array {
        return (data instanceof Message ? (data as MBoolValue) : new MBoolValue(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MBoolValue {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MBoolValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readBool();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MBoolValue {
        return MBoolValue.deserializeBinaryFromReader(new MBoolValue(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MBoolValue, reader: BinaryReader) {
        return Object.assign(msg, MBoolValue.deserialize(reader))
    };

}
export interface IStringValue {
    value?: string;

}
export class StringValue implements IStringValue {

    value?: string;

    constructor(data?: Partial<IStringValue>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MStringValue extends Message implements StringValue {

    constructor(data?: Partial<IStringValue>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): string {
        return Message.getField(this, 1) as string;
    }
    set value(value: string) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new StringValue() : {} as StringValue;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeString(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IStringValue): Uint8Array {
        return (data instanceof Message ? (data as MStringValue) : new MStringValue(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MStringValue {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MStringValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MStringValue {
        return MStringValue.deserializeBinaryFromReader(new MStringValue(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MStringValue, reader: BinaryReader) {
        return Object.assign(msg, MStringValue.deserialize(reader))
    };

}
export interface IBytesValue {
    value?: Uint8Array;

}
export class BytesValue implements IBytesValue {

    value?: Uint8Array;

    constructor(data?: Partial<IBytesValue>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MBytesValue extends Message implements BytesValue {

    constructor(data?: Partial<IBytesValue>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("value" in data && data.value != undefined) this.value = data.value;
        }
    }

    get value(): Uint8Array {
        return Message.getField(this, 1) as Uint8Array;
    }
    set value(value: Uint8Array) {
        Message.setField(this, 1, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new BytesValue() : {} as BytesValue;
        if (this.value != undefined) data.value = this.value;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.value !== undefined) writer.writeBytes(1, this.value);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IBytesValue): Uint8Array {
        return (data instanceof Message ? (data as MBytesValue) : new MBytesValue(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MBytesValue {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MBytesValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.value = reader.readBytes();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MBytesValue {
        return MBytesValue.deserializeBinaryFromReader(new MBytesValue(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MBytesValue, reader: BinaryReader) {
        return Object.assign(msg, MBytesValue.deserialize(reader))
    };

}
                        




export default () => {}